import { Application } from '@hotwired/stimulus'

import ClassTogglerController from './controllers/class_toggler_controller'
import PaginationController from './controllers/pagination_controller'

import FullImageController from './controllers/full_image_controller'
import { LightboxController } from './controllers/full_image_controller'
import ResponsivePictureController from './controllers/responsive_picture_controller'

const application = Application.start()

application.register('class-toggler', ClassTogglerController)
application.register('pagination', PaginationController)
application.register('full-image', FullImageController)
application.register('lightbox', LightboxController)
application.register('responsive-picture', ResponsivePictureController);


(window as any).htmx = require('htmx.org')

